import React from "react"

export default function CookiesConsent({
  hasUserConsentedToCookies,
  setHasUserConsentedToCookies,
}: {
  hasUserConsentedToCookies: boolean | null
  setHasUserConsentedToCookies: (x: boolean) => void
}) {
  // null means the user has neither accepted nor declined
  const hasUserMadeADecisionAboutCookiesConsent =
    hasUserConsentedToCookies !== null

  if (!hasUserMadeADecisionAboutCookiesConsent) {
    return (
      <div className="fixed z-[200] bottom-0">
        <div className="max-w-sm bg-gray-50 dark:bg-slate-900 border border-slate-200 dark:border-slate-700 rounded-lg">
          <div className="flex items-center justify-between p-3">
            <h1 className="text-lg font-medium text-slate-900 dark:text-slate-100">Cookies</h1>
          </div>
          <div className="p-3 -mt-2">
            <p className="text-sm text-left text-zinc-700 dark:text-slate-300">
              We only use cookies to remember your chosen location for
              subsequent visits. This site uses{" "}
              <span className="font-bold">no ads or tracking of any kind.</span>
            </p>
          </div>
          <div className="flex items-center mt-2 gap-2 border-t border-slate-200 dark:border-slate-700">
            <button
              onClick={() => setHasUserConsentedToCookies(false)}
              className="w-full h-14 text-slate-700 dark:text-slate-300"
            >
              Decline
            </button>
            <button
              onClick={() => setHasUserConsentedToCookies(true)}
              className="w-full h-14 bg-sky-500 hover:bg-sky-400 dark:bg-sky-600 dark:hover:bg-sky-500 rounded-br text-white font-bold transition-colors"
            >
              Accept
            </button>
          </div>
        </div>
      </div>
    )
  } else {
    return <></>
  }
}
